/* istanbul ignore file */
import {
  INIT_FORM_STATE,
  ON_CATEGORIES_BENCHMARKS_CHANGE,
  ON_CATEGORY_FILTER_CHANGE,
  SWITCH_CATEGORIES_ORDER,
  TOGGLE_CATEGORY_TOOLBOX,
  TOGGLE_POTENTIAL_SAVINGS
} from './form.state.actions';
import _ from 'lodash';
import {
  calculateCategoriesBenchmarks,
  findCategoryByName
} from './form.state.utils';
import { CATEGORIES_KEYS } from '../../../CategoriesWidget/useCategoriesWidget/useCategoriesWidget';

const formStateReducer = (state, action) => {
  const potentialSavings = state?.[CATEGORIES_KEYS.POTENTIAL_SAVINGS] || {};

  switch (action.type) {
    case INIT_FORM_STATE:
      return {
        ...state,
        ...action.payload
      };
    case TOGGLE_CATEGORY_TOOLBOX:
      const shouldClose = state.selectedCategory?.name === action.payload.name;
      return {
        ...state,
        selectedCategory: shouldClose ? null : action.payload
      };
    case ON_CATEGORY_FILTER_CHANGE:
      const updatedCategory = _.cloneDeep(
        findCategoryByName(state.categories, action.payload.category?.name)
      );
      updatedCategory.filters[action.payload.filterIdx] =
        action.payload.newFilter;

      updatedCategory.filters = updatedCategory.filters.filter(
        filters => !!_.size(filters)
      );

      return {
        ...state,
        categories: state.categories.map(category =>
          category.name === updatedCategory.name ? updatedCategory : category
        )
      };

    case ON_CATEGORIES_BENCHMARKS_CHANGE:
      const newBenchmarks = action.payload;
      return {
        ...state,
        categories: state.categories.map(category => ({
          ...category,
          benchmark: newBenchmarks.find(
            benchmark => benchmark.name === category.name
          ).value
        })),
        ...(potentialSavings.enabled && {
          [CATEGORIES_KEYS.POTENTIAL_SAVINGS]: {
            ...state[CATEGORIES_KEYS.POTENTIAL_SAVINGS],
            benchmark: newBenchmarks[newBenchmarks.length - 1].value
          }
        })
      };

    case TOGGLE_POTENTIAL_SAVINGS:
      const isChecked = action.payload;
      const categoriesBenchmarks = calculateCategoriesBenchmarks({
        categories: state.categories,
        potentialSavings
      });

      return {
        ...state,
        categories: state.categories.map((category, idx) => ({
          ...category,
          benchmark: categoriesBenchmarks[category.key]
        })),
        [CATEGORIES_KEYS.POTENTIAL_SAVINGS]: {
          ...state[CATEGORIES_KEYS.POTENTIAL_SAVINGS],
          enabled: isChecked
        }
      };

    case SWITCH_CATEGORIES_ORDER:
      const { order1, order2 } = action.payload;
      const updatedCategoriesOrdered = state.categories.map(currCat => {
        return {
          ...currCat,
          order:
            currCat.order === order1
              ? order2
              : currCat.order === order2
              ? order1
              : currCat.order
        };
      });
      return { ...state, categories: updatedCategoriesOrdered };

    default:
      return state;
  }
};

export default formStateReducer;
